import { types } from '../types';

export const reducers = {
  [types.SET_SETTINGS]: (state, newSettings) => newSettings
};
